import React from 'react';

import { STAFF_CONNECTIONS_LIST_QUERY_KEY } from '../../Organization/Connections/queryKeys';
import { ConnectionsListPage } from '../../shared/connections';

export const StaffConnectionsList: React.FC = () => {
  return (
    <ConnectionsListPage
      title="Connections"
      queryKeyBase={STAFF_CONNECTIONS_LIST_QUERY_KEY}
      displayTypePrefKey="StaffConnections"
      showOrganization={true}
      showOrganizationFilter={true}
      linkContext="staff"
    />
  );
};
